import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { State } from "appworks/state-machine/states/state";
import { Contract } from "appworks/utils/contracts/contract";
import { AlertComponent } from "slotworks/components/alert/alert-component";

export class ThemeRecoverFreespinsTriggeredState extends State {
    public onEnter(): void {
        const gameplay: Gameplay = gameState.getCurrentGame();
        gameplay.resetToRootRecord();

        this.recoveryPopup().then(() => this.complete());
    }

    protected recoveryPopup(): Contract<void> {
        return Components.get(AlertComponent).recover("rec.spi");
    }
}
